import { useReselector } from '@/utils/sharedHooks'
import { Alert, Text, Link, Icon } from '@/ui'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { TextColors, TypographyStyles } from '@/styles'
import { eoyReviewReviewPeriodNotActive } from '@/features/user/dashboard/user-action-items/lib/userActionItems.selectors'
import { selectCurrentAnnualTaxYear } from '@/features/admin/annual-tax-details/annualTaxDetails.selector'

export const EoyAlertBanner = () => {
  const year = useReselector(selectCurrentAnnualTaxYear)
  const eoyPeriodInactive = useReselector(eoyReviewReviewPeriodNotActive, year)
  if (eoyPeriodInactive) {
    return null
  }
  return (
    <Alert variant="priority">
      <Text variant={TypographyStyles.H3}>
        <b>Action Required:</b> Complete your {year} End-of-Year Review
        <Link
          href="/taxes/annual"
          className="ml-4"
          color={TextColors.GREEN}
          newPage={false}
        >
          Get Started
          <Icon icon={faArrowRight} color={TextColors.GREEN} className="ml-2" />
        </Link>
      </Text>
    </Alert>
  )
}
